import Node from './node';

export default class DisplayText extends Node {
  clone() {
    return new DisplayText(this.text, this.attributes, this.children.map((c) => c.clone()), this.owner);
  }
}
